<template>
  <div class="team-container">
    <div class="grid">
      <AgentCard v-for="agent in agents" :key="agent.id" :agent="agent" />
    </div>
  </div>
</template>

<script>
import AgentCard from './AgentCard.vue';
import img1 from '@/assets/Elazari_hacker_square-1024x1010-1.webp'
import img2 from '@/assets/360_F_493922901_gPyDyy5BvfrDXJd0i5Y5BUYPTNnJzYC3.jpg'
import img3 from '@/assets/images.jpeg'
import img4 from '@/assets/64b00625-ec1f-4e45-832a-bdc622ea354a.769501a4-25c0-4040-bdee-052f1af15f29.webp'
import img5 from '@/assets/agfsdgads.webp'
import img6 from '@/assets/123124.jpeg'
import img7 from '@/assets/rfewqf.jpeg'

export default {
  components: { AgentCard },
  data() {
    return {
      agents: [
        { id: 'FCD-001', name: 'Michael C. Greene', role: 'SENIOR BLOCKCHAIN ANALYST', img: img1 },
        { id: 'FCD-002', name: 'Mason Brooks', role: 'DIGITAL FORENSICS SPECIALIST', img: img2 },
        { id: 'FCD-003', name: 'Liam Walker', role: 'CYBER INTELLIGENCE ANALYST', img: img3 },
        { id: 'FCD-004', name: 'Noah Mitchell', role: 'CRYPTO INVESTIGATION SPECIALIST', img: img4 },
        { id: 'FCD-005', name: 'James Cooper', role: 'INCIDENT RESPONSE MANAGER', img: img5 },
        { id: 'FCD-006', name: 'Benjamin Hayes', role: 'DIGITAL EVIDENCE ANALYST', img: img6 },
        { id: 'FCD-007', name: 'Daniel Foster', role: 'BLOCKCHAIN INVESTIGATION LEAD', img: img7 },
        { id: 'FCD-008', name: 'Olivia Parker', role: 'CLIENT RELATIONS MANAGER', img: img2 }
      ]
    };
  }
}
</script>

<style scoped>
.team-container {
  padding: 0 5% 100px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
}

@media (max-width: 1200px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .grid {
    grid-template-columns: 1fr;
    padding: 0 20px;
  }
}
</style>